import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject, takeUntil, Subscription, finalize } from 'rxjs';
import { MapFilterState } from 'app/shared/components/main-map/components/search-results/map-filter-state.model';
import { FiltersService } from 'app/shared/components/main-map/components/search-results/filters.service';
import { ToastService } from 'app/shared/services/toast.service';
import { LoadingController } from 'app/shared/helpers/loading.controller';
import { MapFilterManager } from '../../map-filter.manager';
import { TranslationService } from '@services/translation.service';

@Component({
  selector: 'app-filter-history',
  templateUrl: 'filter-history.component.html',
  styleUrls: ['filter-history.component.scss'],
})
export class FilterHistoryComponent implements OnInit, OnDestroy {
  @Input()
  visible: boolean;
  @Output()
  visibleChange = new EventEmitter<boolean>();

  itemIdSelected: string;
  itemSelected: MapFilterState;
  items: MapFilterState[];

  private _listLoadSubscription: Subscription;

  private lifecycle = new Subject<void>();

  constructor(
    private filtersService: FiltersService,
    private mapFilterManager: MapFilterManager,
    private toastService: ToastService,
    private loadingController: LoadingController,
    private ts: TranslationService
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.lifecycle.next();
    this.lifecycle.complete();
  }

  onShowingInternal() {
    this.loadFilterStates();
  }

  onHiddenInternal() {
    this._listLoadSubscription?.unsubscribe();

    this.itemIdSelected = null;
    this.itemSelected = null;
  }

  onItemSelected(item: MapFilterState) {
    this.itemSelected = item;
  }

  onBtnDeleteClick(e, item: MapFilterState) {
    e?.stopPropagation();
    if (this.loadingController.isShown()) {
      return;
    }

    this.loadingController.show();
    this.filtersService
      .deleteFilterState(item.id)
      .pipe(
        finalize(() => {
          this.loadingController.hide();
        }),
        takeUntil(this.lifecycle)
      )
      .subscribe({
        next: () => {
          this.toastService.success(
            this.ts.getCurrentLanguage()['filter-deleted-successfully']
          );

          this.loadFilterStates();
        },
        error: (response) => {
          if (!response) {
            return;
          }

          this.toastService.error(
            this.ts.getCurrentLanguage()['failed-delete-history-filter']
          );
        },
      });
  }

  onBtnCancelClick() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  onBtnApplyClick() {
    this.mapFilterManager.loadState(this.itemSelected);

    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  private loadFilterStates() {
    this.loadingController.show();
    this._listLoadSubscription = this.filtersService
      .listFilterStates()
      .pipe(
        finalize(() => {
          this.loadingController.hide();
        }),
        takeUntil(this.lifecycle)
      )
      .subscribe({
        next: (list) => {
          this.items = list;
        },
        error: (response) => {
          if (!response) {
            return;
          }

          this.toastService.error(
            this.ts.getCurrentLanguage()['failed-load-history']
          );
        },
      });
  }
}
